'use client';

import { FC } from 'react';
import { handleClickAttributionClick } from '../core';
import { useUtag } from '../hooks';

export const TrackClickAttribution: FC = () => {
  useUtag(() => {
    document.addEventListener('click', handleClickAttributionClick);

    return () => {
      document.removeEventListener('click', handleClickAttributionClick);
    };
  }, []);

  return null;
};
